// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.p-button-rounded {
display: none;
}

/* Input flotante, arriba a la derecha, sin mover el mapa */
#pac-input {
  position: fixed;
  top: 16px;      /* Ajusta a gusto */
  left: 10%;
  z-index: 1001;
  width: 400px;   /* O el ancho que quieras */
  padding: 10px;
  font-size: 16px;
  border: 2px solid #ddd;
  border-radius: 8px;
  outline: none;
  background-color: white;
}

#pac-input:focus {
  border-color: #FA7317;
}

/* Google Maps InfoWindow — contenedor limpio */
.map-container .gm-style-iw-c {
  padding: 0 !important;
  border-radius: 12px !important;
  box-shadow:
    0 8px 28px rgba(15, 23, 42, 0.14),
    0 0 0 1px rgba(15, 23, 42, 0.06) !important;
  max-height: none !important;
}

.map-container .gm-style-iw-d {
  overflow: hidden !important;
  max-height: none !important;
}

.map-container .gm-style-iw-chr {
  display: none !important;
}

/* Mini-tarjeta dentro del InfoWindow al clickear un pin */
.map-info-card {
  width: 260px;
  font-family: "Inter", sans-serif;
  color: #1e293b;
  overflow: hidden;
}

.map-info-media {
  position: relative;
}

.map-info-close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.94);
  color: #475569;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 1px 5px rgba(15, 23, 42, 0.2);
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.map-info-close:hover {
  background: #fff;
  color: #1e293b;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.22);
}

.map-info-close i {
  font-size: 11px;
}

.map-info-thumb {
  width: 100%;
  height: 130px;
  background-size: cover;
  background-position: center;
  background-color: #f1f5f9;
}

.map-info-thumb--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 28px;
}

.map-info-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px 14px;
}

.map-info-address {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.map-info-price {
  font-size: 17px;
  font-weight: 800;
  color: #fa7317;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.map-info-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.map-info-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #334155;
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.4;
}

.map-info-chip i {
  font-size: 9px;
  color: #64748b;
}

.map-info-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  margin-top: 6px;
  padding: 9px 12px;
  border-radius: 8px;
  background: #fa7317;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 2px 6px rgba(250, 115, 23, 0.3);
}

.map-info-cta:hover {
  background: #e06312;
  color: #fff;
  text-decoration: none;
  box-shadow: 0 3px 10px rgba(250, 115, 23, 0.4);
}

.map-info-cta i {
  font-size: 10px;
}

.map-info-thumb { display: block; object-fit: cover; }
.map-info-ppsqm { display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px; color: #334155; font-size: 13px; font-weight: 700; }
.map-info-ppsqm span { font-size: 10px; font-weight: 400; color: #64748b; }
.map-info-publisher { display: flex; align-items: baseline; gap: 5px; font-size: 12px; line-height: 1.4; color: #64748b; overflow-wrap: anywhere; }
.map-info-publisher__name { color: #1e293b; font-weight: 600; }

@media (max-width: 800px) {
  .map-info-card { display: grid; grid-template-columns: 76px minmax(0, 1fr); width: min(320px, calc(100vw - 48px)); }
  .map-info-media { height: 100%; }
  .map-info-thumb { height: 100%; min-height: 155px; }
  .map-info-close { left: 6px; right: auto; top: 6px; }
  .map-info-body { gap: 4px; padding: 8px; }
  .map-info-address { display: block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 12px; }
  .map-info-price { font-size: 15px; }
  .map-info-ppsqm { font-size: 12px; }
  .map-info-publisher { display: block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 11px; }
  .map-info-chips { gap: 3px; }
  .map-info-chip { padding: 3px 5px; font-size: 9px; }
  .map-info-chip i { display: none; }
  .map-info-cta { margin-top: 2px; padding: 7px 5px; font-size: 11px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Map.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;AACA,aAAa;AACb;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,SAAS,OAAO,mBAAmB;EACnC,SAAS;EACT,aAAa;EACb,YAAY,IAAI,2BAA2B;EAC3C,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,qBAAqB;EACrB,8BAA8B;EAC9B;;+CAE6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wDAAwD;EACxD,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB,cAAc,EAAE,iBAAiB,EAAE;AACrD,kBAAkB,aAAa,EAAE,eAAe,EAAE,qBAAqB,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACtI,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1E,sBAAsB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,uBAAuB,EAAE;AAClJ,4BAA4B,cAAc,EAAE,gBAAgB,EAAE;;AAE9D;EACE,iBAAiB,aAAa,EAAE,0CAA0C,EAAE,qCAAqC,EAAE;EACnH,kBAAkB,YAAY,EAAE;EAChC,kBAAkB,YAAY,EAAE,iBAAiB,EAAE;EACnD,kBAAkB,SAAS,EAAE,WAAW,EAAE,QAAQ,EAAE;EACpD,iBAAiB,QAAQ,EAAE,YAAY,EAAE;EACzC,oBAAoB,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE;EACrH,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,eAAe,EAAE;EACnC,sBAAsB,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE;EACvH,kBAAkB,QAAQ,EAAE;EAC5B,iBAAiB,gBAAgB,EAAE,cAAc,EAAE;EACnD,mBAAmB,aAAa,EAAE;EAClC,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtE","sourcesContent":[".map-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.p-button-rounded {\ndisplay: none;\n}\n\n/* Input flotante, arriba a la derecha, sin mover el mapa */\n#pac-input {\n  position: fixed;\n  top: 16px;      /* Ajusta a gusto */\n  left: 10%;\n  z-index: 1001;\n  width: 400px;   /* O el ancho que quieras */\n  padding: 10px;\n  font-size: 16px;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  outline: none;\n  background-color: white;\n}\n\n#pac-input:focus {\n  border-color: #FA7317;\n}\n\n/* Google Maps InfoWindow — contenedor limpio */\n.map-container .gm-style-iw-c {\n  padding: 0 !important;\n  border-radius: 12px !important;\n  box-shadow:\n    0 8px 28px rgba(15, 23, 42, 0.14),\n    0 0 0 1px rgba(15, 23, 42, 0.06) !important;\n  max-height: none !important;\n}\n\n.map-container .gm-style-iw-d {\n  overflow: hidden !important;\n  max-height: none !important;\n}\n\n.map-container .gm-style-iw-chr {\n  display: none !important;\n}\n\n/* Mini-tarjeta dentro del InfoWindow al clickear un pin */\n.map-info-card {\n  width: 260px;\n  font-family: \"Inter\", sans-serif;\n  color: #1e293b;\n  overflow: hidden;\n}\n\n.map-info-media {\n  position: relative;\n}\n\n.map-info-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.94);\n  color: #475569;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 1px 5px rgba(15, 23, 42, 0.2);\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.map-info-close:hover {\n  background: #fff;\n  color: #1e293b;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.22);\n}\n\n.map-info-close i {\n  font-size: 11px;\n}\n\n.map-info-thumb {\n  width: 100%;\n  height: 130px;\n  background-size: cover;\n  background-position: center;\n  background-color: #f1f5f9;\n}\n\n.map-info-thumb--empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  font-size: 28px;\n}\n\n.map-info-body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 14px 14px;\n}\n\n.map-info-address {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.35;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.map-info-price {\n  font-size: 17px;\n  font-weight: 800;\n  color: #fa7317;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\n.map-info-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.map-info-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 10.5px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.map-info-chip i {\n  font-size: 9px;\n  color: #64748b;\n}\n\n.map-info-cta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  margin-top: 6px;\n  padding: 9px 12px;\n  border-radius: 8px;\n  background: #fa7317;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: 0 2px 6px rgba(250, 115, 23, 0.3);\n}\n\n.map-info-cta:hover {\n  background: #e06312;\n  color: #fff;\n  text-decoration: none;\n  box-shadow: 0 3px 10px rgba(250, 115, 23, 0.4);\n}\n\n.map-info-cta i {\n  font-size: 10px;\n}\n\n.map-info-thumb { display: block; object-fit: cover; }\n.map-info-ppsqm { display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px; color: #334155; font-size: 13px; font-weight: 700; }\n.map-info-ppsqm span { font-size: 10px; font-weight: 400; color: #64748b; }\n.map-info-publisher { display: flex; align-items: baseline; gap: 5px; font-size: 12px; line-height: 1.4; color: #64748b; overflow-wrap: anywhere; }\n.map-info-publisher__name { color: #1e293b; font-weight: 600; }\n\n@media (max-width: 800px) {\n  .map-info-card { display: grid; grid-template-columns: 76px minmax(0, 1fr); width: min(320px, calc(100vw - 48px)); }\n  .map-info-media { height: 100%; }\n  .map-info-thumb { height: 100%; min-height: 155px; }\n  .map-info-close { left: 6px; right: auto; top: 6px; }\n  .map-info-body { gap: 4px; padding: 8px; }\n  .map-info-address { display: block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 12px; }\n  .map-info-price { font-size: 15px; }\n  .map-info-ppsqm { font-size: 12px; }\n  .map-info-publisher { display: block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 11px; }\n  .map-info-chips { gap: 3px; }\n  .map-info-chip { padding: 3px 5px; font-size: 9px; }\n  .map-info-chip i { display: none; }\n  .map-info-cta { margin-top: 2px; padding: 7px 5px; font-size: 11px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
